<template>
  <article class="designTouNeeds_container">
    <h3 class="wow fadeInUp">{{ title }}</h3>
    <section class="content">
      <div class="description wow fadeInUp">
        <img
          :src="getImgUrl(designYourNeeds.img)"
          :alt="title"
          loading="lazy"
          draggable="false"
        />
        <p>{{ designYourNeeds.description }}</p>
        <button @click="showModal">
          {{ designYourNeeds.buttonText }}<i class="fas fa-paintbrush" />
        </button>
      </div>
      <div class="image_container wow bounceIn">
        <img
          src="@/assets/designYourNeeds.webp"
          alt="design your needs Logo"
          loading="lazy"
          draggable="false"
        />
      </div>
    </section>
    <ModalComponent v-model="isShow" :close="closeModal">
      <section class="modal_container">
        <!-- Frist Page -->
        <article
          class="choose_props show"
          ref="chooseProps"
          @animationend="animationEndHandler"
        >
          <div
            class="prop-category-box"
            v-for="(category, i) in Object.keys(designYourNeeds.data)"
            :key="i"
          >
            <h4 class="prop-category">{{ category }}</h4>
            <div class="props_list">
              <div
                v-for="(prop, index) in designYourNeeds.data[category]"
                :key="index"
                :class="{
                  disable: prop.fixed,
                  numeric: prop.type == 'numeric',
                }"
              >
                <ProjectProperty
                  @click="toggleProperty($event, prop)"
                  @keyup="toggleProperty($event, prop)"
                  :ref="prop.name"
                  :property="prop"
                />
              </div>
            </div>
          </div>

          <div class="footer">
            <p>
              <bdi>
                {{ designYourNeeds.designYourNeedsMessage + " " }}
              </bdi>
              <bdi>{{ totalPrice + " " + currency }}</bdi>
            </p>
            <div class="btns_container">
              <button @click="closeModal" class="cancleButton">
                {{ sendRequestData.cancleButtonText }}
              </button>
              <button @click="nextAction" class="nextButton">
                {{ sendRequestData.nextButtonText }}
                <i class="fas fa-forward" />
              </button>
            </div>
          </div>
        </article>
        <!-- Second Page -->
        <article
          ref="submitContainer"
          class="submit_Container"
          @animationend="animationEndHandler"
        >
          <SendClientDataToBuy
            :backAction="backAction"
            :currency="currency"
            :designYourNeeds="designYourNeeds"
            :totalPrice="totalPrice"
            :selectedProps="selectedProps"
            :programName="programName"
            :closeModal="closeModal"
          />
        </article>
      </section>
    </ModalComponent>
  </article>
</template>

<script>
import { getImgUrl } from "@/util/methods";

import SendClientDataToBuy from "@/components/SendClientDataToBuy";
import ProjectProperty from "@/components/ProjectProperty";
export default {
  name: "ProjectPageDesignNeeds",
  data() {
    return {
      isShow: false,
      totalPrice: 0,
      selectedProps: {},
    };
  },
  components: {
    SendClientDataToBuy,
    ProjectProperty,
  },
  methods: {
    getImgUrl,
    getValues(obj) {
      const parentArray = Object.values(obj);
      let result = [];
      for (const childArr of parentArray) {
        result = [...result, ...childArr];
      }
      return result;
    },
    showModal() {
      this.isShow = true;
      this.totalPrice = this.designYourNeeds.basePrice;
      this.selectedProps = this.defaultOption();
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    },
    isCheked(propertyName) {
      return this.selectedProps[propertyName];
    },
    removePropertySelection(propName) {
      // Sub From TotalPrice
      this.totalPrice -= this.selectedProps[propName].totalPrice;
      delete this.selectedProps[propName];
      this.$refs[propName].toggleProperty();
    },
    addPropToSelectedList(prop) {
      this.selectedProps[prop.name] = prop;
      this.$refs[prop.name].toggleProperty();
    },
    addPropertySelection(prop) {
      const price = this.$refs[prop.name].getPrice();
      const num = this.$refs[prop.name].getNum();
      // Add To TotalPrice
      this.totalPrice += price;
      prop.totalPrice = price;
      prop.num = num;
    },
    toggleProperty(event, prop) {
      if (!prop.fixed && event.target.nodeName != "INPUT") {
        if (this.isCheked(prop.name)) {
          /* Check existWith Props */
          const existWith = prop.existWith?.filter(
            (propname) => this.selectedProps[propname]
          );
          if (existWith && existWith.length) {
            return;
          }
          // Sub From TotalPrice
          this.removePropertySelection(prop.name);
        } else {
          this.addPropertySelection(prop);
          this.addPropToSelectedList(prop);
          /* Check Oppiste Props To Clear Selection */
          const { opposite } = prop;
          if (opposite) {
            for (const oppositeProp of opposite) {
              // Sub From TotalPrice
              if (this.selectedProps[oppositeProp]) {
                this.removePropertySelection(oppositeProp);
              }
            }
          }
          /* Check Depends Props To Add Selection */
          const { dependsOn } = prop;
          if (dependsOn) {
            for (const dependsPropName of dependsOn) {
              // Add Selection
              if (!this.isCheked(dependsPropName)) {
                const propery = this.getValues(
                  this.designYourNeeds.data
                ).filter((prop) => prop.name === dependsPropName)[0];
                this.addPropertySelection(propery);
                this.addPropToSelectedList(propery);
              }
            }
          }
        }
      } else if (event.target.nodeName == "INPUT" && this.isCheked(prop.name)) {
        this.totalPrice -= prop.totalPrice;
        /* Increment Num */
        this.addPropertySelection(prop);
      } else if (
        (event.target.nodeName == "INPUT" && event,
        event.pointerType != "mouse")
      ) {
        this.addPropertySelection(prop);
        this.addPropToSelectedList(prop);
      }
    },

    nextAction() {
      this.$refs["chooseProps"].classList.remove("show");
      this.$refs["chooseProps"].classList.add("hide");
      this.$refs["submitContainer"].classList.remove("hide");
      this.$refs["submitContainer"].classList.add("show");
    },
    backAction() {
      this.$refs["submitContainer"].classList.remove("show");
      this.$refs["submitContainer"].classList.add("hide");

      this.$refs["chooseProps"].classList.remove("hide");
      this.$refs["chooseProps"].classList.add("show");
    },
    animationEndHandler(e) {
      if (e.target.className.indexOf("hide") > -1) {
        e.target.classList.remove("hide");
      }
    },
    defaultOption() {
      return this.getValues(this.designYourNeeds.data)
        .filter((item) => item.fixed)
        .reduce((a, b) => {
          a[b.name] = b;
          return a;
        }, {});
    },
  },
  computed: {
    currency() {
      const { lang } = this.$store.state;

      return this.$store.state[lang].currency;
    },
    sendRequestData() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].sendRequestData;
    },
  },
  props: ["title", "designYourNeeds", "programName"],
};
</script>
